import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { setFeature } from "@aws-sdk/core";
import { HttpRequest } from "@smithy/protocol-http";
import { S3_EXPRESS_AUTH_SCHEME, S3_EXPRESS_BACKEND, S3_EXPRESS_BUCKET_TYPE, SESSION_TOKEN_HEADER } from "../constants";
export var s3ExpressMiddleware = function s3ExpressMiddleware(options) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var _endpoint$properties, _endpoint$properties$, _endpoint$properties$2, _endpoint$properties2, _endpoint$properties3, endpoint, isS3ExpressAuth, isS3ExpressBucket, requestBucket, s3ExpressIdentity;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!context.endpointV2) {
                  _context.next = 18;
                  break;
                }
                endpoint = context.endpointV2;
                isS3ExpressAuth = ((_endpoint$properties = endpoint.properties) === null || _endpoint$properties === void 0 ? void 0 : (_endpoint$properties$ = _endpoint$properties.authSchemes) === null || _endpoint$properties$ === void 0 ? void 0 : (_endpoint$properties$2 = _endpoint$properties$[0]) === null || _endpoint$properties$2 === void 0 ? void 0 : _endpoint$properties$2.name) === S3_EXPRESS_AUTH_SCHEME;
                isS3ExpressBucket = ((_endpoint$properties2 = endpoint.properties) === null || _endpoint$properties2 === void 0 ? void 0 : _endpoint$properties2.backend) === S3_EXPRESS_BACKEND || ((_endpoint$properties3 = endpoint.properties) === null || _endpoint$properties3 === void 0 ? void 0 : _endpoint$properties3.bucketType) === S3_EXPRESS_BUCKET_TYPE;
                if (isS3ExpressBucket) {
                  setFeature(context, "S3_EXPRESS_BUCKET", "J");
                  context.isS3ExpressBucket = true;
                }
                if (!isS3ExpressAuth) {
                  _context.next = 18;
                  break;
                }
                requestBucket = args.input.Bucket;
                if (!requestBucket) {
                  _context.next = 18;
                  break;
                }
                _context.t0 = options.s3ExpressIdentityProvider;
                _context.next = 11;
                return options.credentials();
              case 11:
                _context.t1 = _context.sent;
                _context.t2 = {
                  Bucket: requestBucket
                };
                _context.next = 15;
                return _context.t0.getS3ExpressIdentity.call(_context.t0, _context.t1, _context.t2);
              case 15:
                s3ExpressIdentity = _context.sent;
                context.s3ExpressIdentity = s3ExpressIdentity;
                if (HttpRequest.isInstance(args.request) && s3ExpressIdentity.sessionToken) {
                  args.request.headers[SESSION_TOKEN_HEADER] = s3ExpressIdentity.sessionToken;
                }
              case 18:
                return _context.abrupt("return", next(args));
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};
export var s3ExpressMiddlewareOptions = {
  name: "s3ExpressMiddleware",
  step: "build",
  tags: ["S3", "S3_EXPRESS"],
  override: true
};
export var getS3ExpressPlugin = function getS3ExpressPlugin(options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(s3ExpressMiddleware(options), s3ExpressMiddlewareOptions);
    }
  };
};